import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section id="categories" className="relative w-full bg-background-50 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-4xl mx-auto text-center" ref={dropdownRef}>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
          {t("category.grid.title")}
        </h2>
        <p className="text-sm text-foreground-600 mb-8">
          {t("category.grid.subtitle")}
        </p>

        <div className="relative max-w-md mx-auto">
          <button
            onClick={() => setOpen(!open)}
            className="w-full flex items-center justify-between px-5 py-3.5 rounded-lg bg-background-100 border border-background-200/70 text-foreground-800 text-sm hover:border-primary-300 transition-all duration-200 cursor-pointer"
          >
            <span className={open ? "text-foreground-800" : "text-foreground-500"}>
              {open ? t("category.dropdown.label") : t("category.dropdown.placeholder")}
            </span>
            <i
              className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-200 ${
                open ? "rotate-180" : ""
              }`}
            ></i>
          </button>

          {open && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-lg shadow-sm z-30 max-h-[360px] overflow-y-auto">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer first:rounded-t-lg last:rounded-b-lg"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                  {cat.name}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}